import { Children, Fragment, isValidElement } from "react";

import { Divider, Paper, Stack, Typography } from "@mui/material";

interface Props {
  title: string;
  children: React.ReactNode;
}

export function ChecklistSectionCard({ title, children }: Props) {
  const questions = Children.toArray(children).filter(isValidElement);

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Stack gap={2}>
        <Typography variant="h6">{title}</Typography>
        {questions.map((question, index) => (
          <Fragment key={question.key ?? index}>
            {index > 0 && <Divider />}
            {question}
          </Fragment>
        ))}
      </Stack>
    </Paper>
  );
}
